import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import moment from 'moment';
import { TokenService } from '@app/shared/services/token.service';
@Injectable({
  providedIn: 'root',
})
export class IntercomChatbotService {
  constructor(private tokenService: TokenService) {}

  /**
   * Import intercom script
   */
  setIntercomScript() {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.innerHTML = `(function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://widget.intercom.io/widget/${environment.intercom_id}';
          var x = d.getElementsByTagName('script')[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === 'complete') {
          l();
        } else if (w.attachEvent) {
          w.attachEvent('onload', l);
        } else {
          w.addEventListener('load', l, false);
        }
      }
    })();`;
      document.head.appendChild(script);
      resolve(true);
    });
  }

  /**
   * Setup intercom
   */
  async setupIntercom() {
    return new Promise((resolve) => {
      if ((<any>window).Intercom) {
        (<any>window).Intercom('boot', {
          app_id: environment.intercom_id,
          created_at: 1312182000,
        });
      }
      let decodedToken: any = this.tokenService.getDecodedToken();
      if ((<any>window).Intercom) {
        (<any>window).Intercom('update', {
          email: decodedToken.email,
          name: decodedToken.nickname,
          created_at: moment().format(),
          user_id: decodedToken.sub,
        });
      }
      resolve(true);
    });
  }
}
